<!-- 律所主页 -->
<template>
    <div>
        <div v-if="notClaim" class="claim">
            <div class="title">认领律师</div>
            <div class="content">
                <div class="content-upload">
                    <div class="upload-zyz" @mouseenter="changeTip('modalzyz')">
                        <div class="upload-title">
                            上传执业证
                        </div>
                        <div class="upload-sub-title">请您上传执业证号为<span class="zyz-num">{{ qcno }}</span>的律师执业证照片</div>
                        <div class="upload">
                            <veui-uploader
                                v-model="zyzimage"
                                class="portrait"
                                :max-count="1"
                                :accept="imageAccept"
                                max-size="5120kb"
                                :convert-response="(data) => convertResponse(data, 'register_image')"
                                type="image"
                                picker-label="上传律师执业证照片"
                                picker-icon="plus"
                                :action="`${url}&bucketName=law_smart&storeDir=identity_head_image&ajax=true`"
                                @change="res => uploaderChange(res, 'register_image')"
                            >
                            </veui-uploader>
                            <div v-if="formData.register_image && zyzIsEnd" class="upload-info">
                                <div class="info-item">
                                    <div class="info-title">执业证号</div>
                                    <div v-if="formData.register_image_license" class="info-value">
                                        {{ formData.register_image_license }}
                                    </div>
                                    <div v-else class="info-error">解析失败</div>
                                </div>
                                <div class="info-item">
                                    <div class="info-title">身份证号</div>
                                    <div v-if="formData.register_image_identity_no" class="info-value">
                                        {{ formData.register_image_identity_no }}
                                    </div>
                                    <div v-else class="info-error">解析失败</div>
                                </div>
                                <div v-if="zyzIsEnd && zyzErrorMsg" class="info-item">
                                    <div class="info-error-title">失败原因</div>
                                    <div class="info-error-value">
                                        <span class="info-value">{{ zyzErrorMsg }}</span>
                                        <span class="info-error-btn" @click="handleBtnClick('人工审核', '识别失败')">人工审核</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="upload-zyz" @mouseenter="changeTip('modalsfz')">
                        <div class="upload-title">
                            上传身份证明
                        </div>
                        <div v-if="formData.register_image_identity_no" class="upload-sub-title">请您上传身份证号为<span class="zyz-num">{{ formData.register_image_identity_no }}</span>的身份证照片</div>
                        <div class="upload">
                            <veui-uploader
                                v-model="sfzzimage"
                                :max-count="1"
                                class="portrait"
                                :accept="imageAccept"
                                max-size="5120kb"
                                :convert-response="(data) => convertResponse(data, 'identity_head_image')"
                                type="image"
                                picker-label="上传人像面"
                                picker-icon="plus"
                                :action="`${url}&bucketName=law_smart&storeDir=identity_head_image&ajax=true`"
                                @change="res => uploaderChange(res, 'identity_head_image')"
                            >
                            </veui-uploader>
                            <veui-uploader
                                v-model="sfzfimage"
                                class="portrait"
                                :max-count="1"
                                :accept="imageAccept"
                                max-size="5120kb"
                                :convert-response="(data) => convertResponse(data, 'identity_national_image')"
                                type="image"
                                picker-label="上传国徽面"
                                picker-icon="plus"
                                :action="`${url}&bucketName=law_smart&storeDir=identity_national_image&ajax=true`"
                                @change="res => uploaderChange(res, 'identity_national_image')"
                            >
                            </veui-uploader>
                            <div v-if="(formData.identity_head_image || formData.identity_national_image) && (sfzzIsEnd || sfzfIsEnd)" class="upload-info">
                                <div v-if="formData.identity_head_image" class="info-item">
                                    <div class="info-title">身份证号</div>
                                    <div v-if="formData.identity_no" class="info-value">{{ formData.identity_no }}</div>
                                    <div v-else class="info-error">解析失败</div>
                                </div>
                                <div v-if="formData.identity_head_image && sfzzIsEnd && sfzzErrorMsg" class="info-item">
                                    <div class="info-error-title">失败原因</div>
                                    <div class="info-error-value">
                                        <span class="info-value">{{ sfzzErrorMsg }}</span>
                                        <span class="info-error-btn" @click="handleBtnClick('人工审核', '识别失败')">人工审核</span>
                                    </div>
                                </div>
                                <div v-if="formData.identity_national_image && sfzfIsEnd && sfzfErrorMsg" class="info-item">
                                    <div class="info-error-title">失败原因</div>
                                    <div class="info-error-value">
                                        <span class="info-value">{{ sfzfErrorMsg }}</span>
                                        <span class="info-error-btn" @click="handleBtnClick('人工审核', '识别失败')">人工审核</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="(sfzzIsEnd && sfzfIsEnd) && formData.identity_head_image && formData.identity_national_image && !sfzzErrorMsg && !sfzfErrorMsg" class="phone-box">
                            <veui-form
                                :data="formData"
                            >
                                <veui-field
                                    label="手机号"
                                    name="phone"
                                    :class="phoneError ? 'phone-error' : ''"
                                    :rules="[{name: 'required'}]"
                                >
                                    <veui-number-input
                                        v-model="formData.user_phone"
                                        clearable
                                        autocomplete="off"
                                        :maxlength="11"
                                        strict
                                        placeholder="请输入手机号"
                                        @change="checkPhone"
                                    />
                                </veui-field>
                                <div v-if="phoneError" class="phone-error-tip">请输入正确的手机号</div>
                                <veui-field
                                    label="验证码"
                                    name="code"
                                    :class="codeError ? 'code-error' : ''"
                                    :rules="[{name: 'required'}]"
                                >
                                    <veui-number-input
                                        v-model="formData.code"
                                        autocomplete="off"
                                        :maxlength="4"
                                        strict
                                        placeholder="请输入验证码"
                                        @change="checkCode"
                                    />
                                    <div
                                        v-if="!isSendCode && isFirstSend"
                                        class="code-text"
                                        @click="sendCode"
                                    >获取验证码</div>
                                    <div v-if="isSendCode" class="code-text">{{ verificationCountDown }}s</div>
                                    <div
                                        v-if="!isSendCode && !isFirstSend"
                                        class="code-text"
                                        @click="sendCode"
                                    >重新获取</div>
                                </veui-field>
                                <div v-if="codeError" class="phone-error-tip">{{ codeErrorMsg }}</div>
                            </veui-form>
                        </div>
                    </div>
                </div>
                <div class="content-tip">
                    <div class="tip">
                        <div class="tip-title">{{ currentModalData.title }}</div>
                        <div
                            v-for="item,index in currentModalData.tip"
                            :key="'tip' + index"
                            class="tip-prompt"
                        >{{ item }}</div>
                        <div
                            v-for="item,index in currentModalData.imgItem"
                            :key="'case' + index"
                            class="tip-case"
                        >
                            <div class="case-img">
                                <img :src="item.url" alt="">
                                <div class="case-tip">{{ item.text }}</div>
                            </div>
                            <div class="tip-rule">
                                <div class="rule-item">
                                    <img class="rule-icon" src="https://lvlin-base.cdn.bcebos.com/fe-saas/common/complete-icons.png">四角完整
                                </div>
                                <div class="rule-item">
                                    <img class="rule-icon" src="https://lvlin-base.cdn.bcebos.com/fe-saas/common/complete-icons.png">亮度均匀
                                </div>
                                <div class="rule-item">
                                    <img class="rule-icon" src="https://lvlin-base.cdn.bcebos.com/fe-saas/common/complete-icons.png">照片清晰
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="declare">
                — 所有照片仅用于审核，法行宝确保你的信息安全 —
            </div>
            <div class="bottom-box">
                <div
                    class="form-agree"
                >
                    <veui-checkbox v-model="formData.isAgree" :false-value="null">我已阅读并知晓 </veui-checkbox>
                    <span class="form-href-terms" @click.stop="goto('serve')">《律师入驻服务条款》</span>
                    <span class="form-href-terms" @click.stop="goto('agree')">《信息真实承诺书》</span>
                    <span class="form-href-terms" @click.stop="goto('phone')">《联系方式授权协议》</span>
                </div>
                <div :class="['submit-btn', canSubmit ? 'submit-btn-blue' : '']" @click="submitForm">提交</div>
            </div>
            <div
                v-if="showModal"
                class="mark"
                @click="closeModal(popupData.subTitle)"
            >
                <div class="modal-content">
                    <div>
                        <div class="modal-title">{{ popupData.title }}</div>
                        <div class="sub-title">{{ popupData.subTitle }}</div>
                    </div>
                    <div class="btn">
                        <div
                            class="btn-item btn-left"
                            :class="popupData.blueBtnText === '我的律师主页' ? 'long-btn' : ''"
                            @click="handleBtnClick(popupData.btnText, popupData.title)"
                        >{{ popupData.btnText }}</div>
                        <div
                            v-if="popupData.blueBtnText"
                            class="btn-item btn-right"
                            :class="popupData.blueBtnText === '我的律师主页' ? 'long-btn' : ''"
                            @click="handleBtnClick(popupData.blueBtnText, popupData.title)"
                        >{{ popupData.blueBtnText }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="claim-suc">
            <div class="title">认领律师</div>
            <div class="result">
                <img class="result-icon" src="https://lvlin-base.cdn.bcebos.com/sp-saas/sub-authentice/claim-lawyer/claim-success.png"/>
                <div class="result-title">认领成功</div>
                <div class="result-sub-title">
                    恭喜您完成<span class="sub-title-black">{{ qcno }}</span>律师认领!
                </div>
                <div class="result-sub-title">
                    快去点亮百度认证，修改/完善律师主页吧
                </div>
                <div class="result-btn-box">
                    <div class="result-btn" @click="toHomePage">进入法行宝律师平台</div>
                    <div class="result-blue-btn" @click="toSpAuthentice">立即认证</div>
                </div>
            </div>
        </div>
        <div v-if="isLoading" class="loading">
            <veui-loading
                loading
                ui="l"
            >
                图片识别中
            </veui-loading>
        </div>
    </div>
</template>

<script>
/**
 * @file claim-lawyer.vue
 * @author sunhemeng
 * @desc 认领页面
 */
import {
    Uploader,
    Checkbox,
    Field,
    Form,
    NumberInput,
    Loading
} from 'veui';
import {mapState} from 'vuex';
import {withBase} from '@/utils/basePath';

export default {
    name: 'cliamLawyer',
    components: {
        'veui-uploader': Uploader,
        'veui-checkbox': Checkbox,
        'veui-field': Field,
        'veui-form': Form,
        'veui-number-input': NumberInput,
        'veui-loading': Loading
    },
    computed: {
        ...mapState({
            userInfoNew: state => state.lawStore.userInfoNew || {},
            lawBusinessInfo: state => state.lawStore.userInfoNew?.law_business_info || {},
            vipInfo: state => state.lawStore.vipInfo || {},
            // 律师uk
            useruk: state => state.lawStore.userInfoNew.uk || ''
        })
    },
    watch: {
        userInfoNew: {
            immediate: true,
            handler(val) {
                const {lawyer_info = {}, user_role} = val || {};
                if ((lawyer_info && lawyer_info.qc_core_no) || user_role === 1 || user_role === 2 || user_role === 3) {
                    // 判断当前用户是否为法行宝入驻律师
                    this.showModal = true;
                    this.popupData = {
                        title: '认领失败',
                        subTitle: '当前百度账号已入驻法行宝，不可认领其他律师',
                        blueBtnText: user_role === 2 || user_role === 3 ? '' : '我的律师主页',
                        btnText: '问题反馈'
                    };
                    this.$wywLog.send({
                        serverId: 18622,
                        action: 'show',
                        page: 'claim-lawyer',
                        area: 'registered_allshow'
                    });
                }
            }
        },
        // 下面是校验提交按钮是否高亮
        formData: {
            immediate: true,
            handler(val) {
                let phone = this.formData.user_phone;
                this.canSubmit = this.allFieldsHaveValues(val) && this.formData.isAgree && this.getValidateObj(phone);
            }
        }
    },
    data() {
        return {
            urlParams: {},
            // 是否认领
            notClaim: true,
            // 律师id
            qcno: '',
            // 律师姓名
            lawyerName: '',
            // 本地要存储的数据
            storageData: {},
            // 提交的数据
            formData: {
                isAgree: true
            },
            imageAccept: '.jpg,.png,.jpeg,.gif,.wbmp,.xbm',
            // 上传接口
            url: '/bp/api/upload?ajax=1&bdstoken=',
            currentModalData: {
                title: '如何上传律师执业证',
                tip: [
                    '1、请提供完整、清晰的律师执业证照片;',
                    '2、执业证号需与所选执业证号一致;',
                    '3、执业证照片需可清晰看出执业证号、身份证号;',
                    '4、照片5M以内，支持jpg/jpeg/png格式。'
                ],
                imgItem: [
                    {
                        url: 'https://lvlin-base.cdn.bcebos.com/fe-saas/common/zyrz-icons.png',
                        text: '示例：律师执业证'
                    }
                ]
            },
            // 提示
            modalzyz: {
                title: '如何上传律师执业证',
                tip: [
                    '1、请提供完整、清晰的律师执业证照片;',
                    '2、执业证号需与所选执业证号一致;',
                    '3、执业证照片需可清晰看出执业证号、身份证号;',
                    '4、照片5M以内，支持jpg/jpeg/png格式。'
                ],
                imgItem: [
                    {
                        url: 'https://lvlin-base.cdn.bcebos.com/fe-saas/common/zyrz-icons.png',
                        text: '示例：律师执业证'
                    }
                ]
            },
            modalsfz: {
                title: '如何上传身份证明',
                tip: [
                    '1、请提供完整、清晰的身份证原件;',
                    '2、身份证号需与执业证中的身份证号一致;',
                    '3、身份证照片需可清晰看出身份证号;',
                    '4、照片5M以内，支持jpg/jpeg/png格式。'
                ],
                imgItem: [
                    {
                        url: 'https://lvlin-base.cdn.bcebos.com/sp-saas/sub-authentice/claim-lawyer/sfz-z.png',
                        text: '示例：身份证（头像面)'
                    },
                    {
                        url: 'https://lvlin-base.cdn.bcebos.com/sp-saas/sub-authentice/claim-lawyer/sfz-f.png',
                        text: '示例：身份证（国徽面)'
                    }
                ]
            },
            // 是否展示弹窗
            showModal: false,
            // 弹窗数据
            popupData: {},
            // 识别中的loading
            isLoading: false,
            // 执业证是否识别完成
            zyzIsEnd: false,
            // 执业证错误信息
            zyzErrorMsg: '',
            // 身份证是否识别完成
            sfzzIsEnd: false,
            sfzfIsEnd: false,
            // 身份证错误信息
            sfzzErrorMsg: '',
            sfzfErrorMsg: '',
            // 图片保存的路径
            zyzimage: [],
            sfzzimage: [],
            sfzfimage: [],
            // 手机号是否有误
            phoneError: false,
            // 验证码是否有误
            codeError: false,
            // 验证码错误信息
            codeErrorMsg: '请输入正确的验证码',
            // 是否发送验证码中
            isSendCode: false,
            // 是否第一次发送验证码
            isFirstSend: true,
            // 验证码倒计时
            verificationCountDown: ''
        };
    },
    created() {
        // 获取url参数，进行保存
        const query = this.$route.query;
        this.urlParams = query;
        this.qcno = query.qcno;
        this.lawyerName = query.lname;
        this.formData.license = query.qcno;
        this.$wywLog.addKey({
            serverId: 18622,
            page: 'claim-lawyer',
            fr: this.urlParams.fr
        });
        this.$wywLog.send({
            action: 'pv',
            area: 'all_show'
        });
    },
    methods: {
        changeTip(type) {
            this.currentModalData = type === 'modalsfz' ? this.modalsfz : this.modalzyz;
        },
        // 跳转主页
        toHomePage() {
            this.$wywLog.send({
                action: 'click',
                page: 'claim-lawyer-success',
                area: 'picksuccess_lvlinb'
            });
            window.location.href = `https://lvlin.baidu.com${withBase('/lawinfo')}?fr=${this.urlParams.fr}`;
        },
        // 跳转律师认证页面
        toSpAuthentice() {
            this.$wywLog.send({
                action: 'click',
                page: 'claim-lawyer-success',
                area: 'picksuccess_certificate'
            });
            window.location.href = `https://lvlin.baidu.com${withBase('/material')}?fr=${this.urlParams.fr}`;
        },
        /**
         * 提交策略
         */
        submitForm() {
            const submitData = this.formData;
            this.$wywLog.send({
                action: 'click',
                area: 'submit_btn',
                index: 0
            });
            if (!submitData.register_image || !submitData.register_image_license || !submitData.register_image_identity_no) {
                this.$Message.error('请上传执业证照片');
                return;
            }
            if (!submitData.identity_head_image || !submitData.identity_no) {
                this.$Message.error('请上传身份证正面照片');
                return;
            }
            if (!submitData.identity_national_image) {
                this.$Message.error('请上传身份证反面照片');
                return;
            }
            if (!submitData.user_phone) {
                this.$Message.error('请输入手机号');
                return;
            }
            if (!submitData.code) {
                this.$Message.error('请输入验证码');
                return;
            }
            if (!submitData.isAgree) {
                this.$Message.error('请阅读并同意相关协议');
                return;
            }
            if (!this.getValidateObj(submitData.user_phone)) {
                this.phoneError = true;
                return;
            }
            if (!/^\d{4}$/.test(submitData.code)) {
                this.codeError = true;
                this.codeErrorMsg = '请输入正确的验证码';
                return;
            }
            this.$wywLog.send({
                action: 'click',
                area: 'submit_btn',
                index: 1
            });
            this.$http.post('/bp/api/user/claim', {
                ...submitData,
                fr: this.urlParams.fr
            }).then(res => {
                if (+res.code === 0) {
                    localStorage.setItem(this.useruk, JSON.stringify(this.storageData));
                    this.notClaim = false;
                    this.$wywLog.send({
                        action: 'pv',
                        page: 'claim-lawyer-success',
                        area: 'picksuccess_allshow'
                    });
                }
                else {
                    let code = res.code;
                    if (code === '12006') {
                        this.showModal = true;
                        this.popupData = {
                            title: '认领失败',
                            subTitle: res.msg,
                            blueBtnText: '我的律师主页',
                            btnText: '问题反馈'
                        };
                        this.$wywLog.send({
                            action: 'show',
                            area: 'registered_allshow'
                        });
                    }
                    else if (code === '12007') {
                        this.showModal = true;
                        this.popupData = {
                            title: '认领失败',
                            subTitle: res.msg,
                            blueBtnText: '返回并刷新',
                            btnText: '问题反馈'
                        };
                        this.$wywLog.send({
                            action: 'show',
                            area: 'picked_allshow'
                        });
                    }
                    else if (code === '12004' || code === '12005' || code === '12003') {
                        this.$Message.error(res.msg);
                        this.codeError = true;
                        this.codeErrorMsg = res.msg;
                    }
                    else {
                        this.showModal = true;
                        this.popupData = {
                            title: '认领失败',
                            subTitle: res.msg,
                            blueBtnText: '人工审核',
                            btnText: '返回修改',
                            code
                        };
                        this.$wywLog.send({
                            action: 'show',
                            area: 'cannotmatch_allshow',
                            index: code === '12001'
                                ? '01'
                                : code === '12002'
                                    ? '02'
                                    : '03'
                        });
                    }
                }
            }).catch(err => {
                this.$Message.error('请求失败，请重试');
            });
        },
        /**
         * 校验json是否都有值
         * jsonObj json数据
         */
        allFieldsHaveValues(jsonObj) {
            for (const key in jsonObj) {
                if (jsonObj.hasOwnProperty(key)) {
                    const value = jsonObj[key];
                    if (value == null || value === '' || (typeof value === 'object' && Object.keys(value).length === 0)) {
                        return false;
                    }
                }
            }
            return true;
        },
        /**
         * 手机号格式校验
         * code 输入框内容
         */
        getValidateObj(value) {
            return /^1(3|5|7|8|9)[0-9]{9}$/.test(value);
        },
        // 手机号回调
        checkPhone(phone) {
            this.phoneError = !this.getValidateObj(phone);
        },
        // 验证码回调
        checkCode(code) {
            this.codeError = !/^\d{4}$/.test(code);
            this.codeErrorMsg = '请输入正确的验证码';
        },
        /**
         * 发送验证码
         */
        sendCode() {
            if (this.isSendCode) {
                return;
            }
            this.isSendCode = true;
            let mobileNumber = this.formData.user_phone;
            if (!this.getValidateObj(mobileNumber)) {
                this.phoneError = true;
                this.isSendCode = false;
                return;
            }
            if (this.codeTimer) {
                clearInterval(this.codeTimer);
                this.codeTimer = null;
            }
            const params = {
                phone: mobileNumber,
                type: 'lawyer_claim',
                vn: 'law'
            };
            this.$http.get('/falv/common/sendcode', {
                params
            });
            this.isFirstSend = false;
            this.verificationCountDown = 60;
            this.codeTimer = setInterval(() => {
                if (this.verificationCountDown >= 1) {
                    this.verificationCountDown = this.verificationCountDown - 1;
                }
                else {
                    clearInterval(this.codeTimer);
                    this.codeTimer = null;
                    this.isSendCode = false;
                }
            }, 1000);
        },
        convertResponse(data, key) {
            return ({
                success: data && (Number(data.code) === 0),
                src: data && data.data && data.data.bos_url,
                message: data.msg
            });
        },
        // 上传图片回调
        uploaderChange(res, key) {
            if (res && res.src) {
                this.formData[key] = res.src;
                this.smartStruct(res.src, key);
                this.isLoading = true;
                if (key === 'register_image') {
                    this.$wywLog.send({
                        action: 'click',
                        area: 'zhiye_btn'
                    });
                }
                else if (key === 'identity_head_image') {
                    this.$wywLog.send({
                        action: 'click',
                        area: 'renxiang_btn'
                    });
                }
                else if (key === 'identity_national_image') {
                    this.$wywLog.send({
                        action: 'click',
                        area: 'guohui_btn'
                    });
                }
                return;
            }
            // 删除图片回调
            if (!res && key === 'register_image') {
                this.formData = {
                    ...this.formData,
                    license: this.qcno, // 执业证号
                    register_image_license: '', // 执业证照片识别出的执业证号
                    register_image: '', // 执业证照片
                    register_image_identity_no: '' // 执业证照片识别出的身份证号
                };
                this.storageData = {
                    ...this.storageData,
                    register_firm: '',
                    lawyer_position: '',
                    register_id: '',
                    issuing_authority: '',
                    register_image: ''
                };
                this.zyzimage = [];
                this.zyzErrorMsg = '';
            }
            if (!res && key === 'identity_head_image') {
                this.formData = {
                    ...this.formData,
                    identity_no: '',
                    identity_head_image: ''
                };
                this.storageData = {
                    ...this.storageData,
                    gender: '',
                    identity_head_image: '' // 身份证正面-个人面
                };
                this.sfzzimage = [];
                this.sfzzErrorMsg = '';
            }
            if (!res && key === 'identity_national_image') {
                this.formData = {
                    ...this.formData,
                    identity_national_image: ''
                };
                this.storageData = {
                    ...this.storageData,
                    identity_national_image: '' // 身份证正面-国徽面
                };
                this.sfzfimage = [];
                this.sfzfErrorMsg = '';
            }
        },
        // 关闭弹窗
        closeModal(value) {
            if (value !== '当前百度账号已入驻法行宝，不可认领其他律师' && value !== '该律师已被认领，不支持再次认领') {
                this.showModal = false;
            }
        },
        /**
         * 异常、错误、失败弹窗按钮点击处理
         * text 点击按钮的文案
         * title 点击弹窗的title
         */
        handleBtnClick(text, title) {
            if (text === '我的律师主页') {
                this.$wywLog.send({
                    action: 'click',
                    area: 'registered_homepage'
                });
                window.location.href = `https://lvlin.baidu.com/pages/experthome/index?rs_id=4941&qc_no=${this.userInfoNew.lawyer_info.register_id}&vn=law&fr=claimLawyerPc`;
            }
            else if (text === '问题反馈') {
                this.$wywLog.send({
                    action: 'click',
                    area: this.popupData.blueBtnText === '返回并刷新' ? 'picked_feedback' : 'registered_feedback'
                });
                this.showModal = false;
                let {qcno, lawyerName = ''} = this || {};
                qcno = qcno && qcno.slice(-6) || '';
                let lawyer = qcno + '_' + lawyerName;
                let target = 'https://ufosdk.baidu.com/ufosdk/postview/hUsmc3gYYf%2BX%2B79r9RFJJQ%3D%3D/242875?';
                target += encodeURIComponent(`extend_url=${lawyer}`);
                window.location.href = target;
            }
            else if (text === '返回修改' || text === '重新上传') {
                this.$wywLog.send({
                    action: 'click',
                    area: text === '重新上传' ? 'sbsb-cxsc-btn' : 'cannotmatch_revise',
                    ...text !== '重新上传' && ({
                        index: this.popupData.code === '12001'
                            ? '01'
                            : this.popupData.code === '12002'
                                ? '02'
                                : '03'
                    }) || {}
                });
                this.showModal = false;
            }
            else if (text === '人工审核') {
                if (title === '识别失败') {
                    this.$wywLog.send({
                        action: 'click',
                        area: 'sbsb_cannotmath_check'
                    });
                }
                else {
                    this.$wywLog.send({
                        action: 'click',
                        area: 'cannotmath_check',
                        index: this.popupData.code === '12001'
                            ? '01'
                            : this.popupData.code === '12002'
                                ? '02'
                                : '03'
                    });
                }
                this.$router.push({
                    name: 'filldata',
                    query: {
                        fr: this.urlParams.fr,
                        name: this.urlParams.name,
                        city: this.urlParams.city,
                        qcno: this.urlParams.qcno
                    }
                });
            }
            else if (text === '返回并刷新') {
                this.$wywLog.send({
                    action: 'click',
                    area: 'picked_back'
                });
                window.history.back();
            }
        },
        /**
         * 图片识别，返回识别结果分三种类型处理
         */
        smartStruct(url, type) {
            this.$http.post('/bp/api/smart_struct', {
                url,
                type: type === 'register_image' ? 1 : 2
            }).then(res => {
                this.isLoading = false;
                // 识别失败，弹窗并返回
                if (res.code !== '0') {
                    const cardText = type === 'register_image' ? '执业证' : type === 'identity_head_image' ? '身份证-个人面' : '身份证-国徽面';
                    // this.$wywLog.send({
                    //     area: 'sbsb',
                    //     action: 'show',
                    //     imageType: type
                    // });
                    if (type === 'register_image') {
                        this.zyzErrorMsg = cardText + '未识别到或识别不全，请重新上传清晰照片或手动填写认证信息提交';
                        this.zyzIsEnd = true;
                    }
                    else if (type === 'identity_head_image') {
                        this.sfzzIsEnd = true;
                        this.sfzzErrorMsg = cardText + '未识别到或识别不全，请重新上传清晰照片或手动填写认证信息提交';
                    }
                    else {
                        this.sfzfIsEnd = true;
                        this.sfzfErrorMsg = cardText + '未识别到或识别不全，请重新上传清晰照片或手动填写认证信息提交';
                    }
                    return;
                }
                // 处理执业证信息
                if (type === 'register_image') {
                    const group = res.data.words_result.struct_info.group || [];
                    let register_firm = '';
                    let lawyer_position = '';
                    let register_id = '';
                    let issuing_authority = '';
                    let register_image_license = '';
                    let register_image_identity_no = '';
                    group.map(item => {
                        if (item.key[0] && item.key[0].word === '执业证号') {
                            register_id = item.value[0].word;
                            register_image_license = item.value[0].word;
                        }
                        else if (item.key[0] && item.key[0].word === '身份证号') {
                            register_image_identity_no = item.value[0].word;
                        }
                        else if (item.key[0] && item.key[0].word === '执业机构') {
                            register_firm = item.value[0].word;
                        }
                        else if (item.key[0] && item.key[0].word === '发证机关') {
                            issuing_authority = item.value[0].word;
                        }
                        else if (item.key[0] && item.key[0].word === '执业证类别') {
                            lawyer_position = item.value[0].word;
                        }
                        return item;
                    });
                    if (!register_id || !register_image_identity_no || register_id.length !== 17 || register_image_identity_no.length !== 18) {
                        let errorVal = '';
                        if (!register_id || register_id.length !== 17) {
                            errorVal = '执业证号';
                        }
                        if (!register_image_identity_no || register_image_identity_no.length !== 18) {
                            errorVal = errorVal ? errorVal + '、身份证号' : '身份证号';
                        }
                        // this.$wywLog.send({
                        //     area: 'sbsb',
                        //     action: 'show',
                        //     imageType: type
                        // });
                        this.zyzErrorMsg = errorVal + '未识别到或识别不全，请重新上传清晰照片或手动填写认证信息提交';
                        this.zyzIsEnd = true;
                        this.formData = {
                            ...this.formData,
                            register_image_license,
                            register_image_identity_no,
                            register_image: url
                        };
                        return;
                    }
                    this.formData = {
                        ...this.formData,
                        register_image_license,
                        register_image_identity_no,
                        register_image: url
                    };
                    this.storageData = {
                        ...this.storageData,
                        register_firm, // 律所
                        lawyer_position, // 律师职务
                        register_id, // 执业证号
                        issuing_authority, // 发证机关
                        register_image: url // 执业证照片
                    };
                    this.zyzErrorMsg = '';
                    this.zyzIsEnd = true;
                    this.zyzimage = [{'key': 0, 'src': url}];
                }
                // 处理身份证信息
                if (type === 'identity_head_image') {
                    const group = res.data || {};
                    if (!group.id_card_no || group.id_card_no.length !== 18) {
                        // this.$wywLog.send({
                        //     area: 'sbsb',
                        //     action: 'show',
                        //     imageType: type
                        // });
                        this.sfzzIsEnd = true;
                        this.sfzzErrorMsg = '身份证个人面未识别到或识别不全，请重新上传清晰照片或手动填写认证信息提交';
                        this.formData = {
                            ...this.formData,
                            identity_no: group.id_card_no,
                            identity_head_image: url
                        };
                        return;
                    }
                    this.formData = {
                        ...this.formData,
                        identity_no: group.id_card_no,
                        identity_head_image: url
                    };
                    this.storageData = {
                        ...this.storageData,
                        gender: group.sex,
                        identity_head_image: url // 身份证正面-个人面
                    };
                    this.sfzzErrorMsg = '';
                    this.sfzzIsEnd = true;
                    this.sfzzimage = [{'key': 0, 'src': url}];
                }
                // 处理身份证国徽面信息
                if (type === 'identity_national_image') {
                    const group = res.data;
                    if (!group.issue_office) {
                        this.sfzfIsEnd = true;
                        this.sfzfErrorMsg = '身份证国徽面未识别到或识别不全，请重新上传清晰照片或手动填写认证信息提交';
                        // this.$wywLog.send({
                        //     area: 'sbsb',
                        //     action: 'show',
                        //     imageType: type
                        // });
                        this.formData = {
                            ...this.formData,
                            identity_national_image: url
                        };
                        return;
                    }
                    this.formData = {
                        ...this.formData,
                        identity_national_image: url
                    };
                    this.storageData = {
                        ...this.storageData,
                        identity_national_image: url // 身份证正面-国徽面
                    };
                    this.sfzfErrorMsg = '';
                    this.sfzfIsEnd = true;
                    this.sfzfimage = [{'key': 0, 'src': url}];
                }
                this.showModal = false;
            }).catch(err => {
                const cardText = type === 'register_image' ? '执业证' : type === 'identity_head_image' ? '身份证-个人面' : '身份证-国徽面';
                if (type === 'register_image') {
                    this.zyzErrorMsg = cardText + '未识别到或识别不全，请重新上传清晰照片或手动填写认证信息提交';
                    this.zyzIsEnd = true;
                }
                else if (type === 'identity_head_image') {
                    this.sfzzIsEnd = true;
                    this.sfzzErrorMsg = cardText + '未识别到或识别不全，请重新上传清晰照片或手动填写认证信息提交';
                }
                else {
                    this.sfzfIsEnd = true;
                    this.sfzfErrorMsg = cardText + '未识别到或识别不全，请重新上传清晰照片或手动填写认证信息提交';
                }
                this.isLoading = false;
            });
        },
        // 协议跳转
        goto(type) {
            if (type === 'serve') {
                window.open('https://lvlin-fe-saas.cdn.bcebos.com/lawyer_rule.pdf');
            }
            else if (type === 'city') {
                window.open('https://lvlin-base.cdn.bcebos.com/fe-saas/common/city_level.pdf');
            }
            else if (type === 'phone') {
                window.open('https://youjia-image.cdn.bcebos.com/pdf/law-smartapp/phone_apply_rule.pdf');
            }
            else {
                window.open('https://youjia-image.cdn.bcebos.com/pdf/law-smartapp/160705507337529aaa5c.pdf');
            }
        }
    }
};
</script>

<style lang='less' scoped>

.title {
    font-family: PingFang SC;
    font-size: 24px;
    font-weight: 500;
    line-height: 24px;
    text-align: center;
    color: #1e1f24;
}

.claim {
    width: 1338px;
    margin: -48px auto 0;

    .content {
        display: flex;

        .content-upload {
            width: 994px;
            margin-right: 20px;
            margin-top: 24px;

            .upload-zyz {
                background: #fff;
                border-radius: 16px;
                padding: 24px;
                box-sizing: border-box;
                box-shadow: 0px 6px 14px 0px rgba(227, 233, 237, 0.35);
                margin-bottom: 20px;

                .upload-title {
                    font-family: PingFang SC;
                    font-size: 20px;
                    font-weight: 600;
                    line-height: 20px;
                    color: rgba(30, 31, 36, 1);
                }

                .upload-sub-title {
                    font-family: PingFang SC;
                    font-size: 14px;
                    line-height: 14px;
                    margin-top: 12px;
                    color: rgba(132, 134, 145, 1);

                    .zyz-num {
                        color: rgba(30, 31, 36, 1);
                    }
                }
                .upload {
                    margin-top: 24px;
                    display: flex;

                    .portrait {
                        margin-right: 12px;
                    }

                    /deep/ .veui-uploader-list-media-container {
                        width: 150px;
                        height: 150px;
                        border: 1px solid #E9ECF3;
                        border-radius: 6px;
                    }

                    /deep/ .veui-uploader {
                        width: 150px;
                        height: 150px;
                        font-size: 12px;
                    }

                    /deep/ .veui-uploader-input-label-media .veui-icon {
                        height: 20px;
                        margin-bottom: 10px;
                        color: #848691;
                    }

                    /deep/ .veui-uploader-input-label-media .veui-uploader-media-button-text {

                        color: #848691;
                    }

                    /deep/ .veui-button[ui~="basic"] {
                        border-color: #E9ECF3;
                    }

                    .upload-info {
                        flex: 1;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: flex-start;
                        margin-left: 8px;

                        .info-item {
                            display: flex;
                            margin: 9px 0;
                            font-family: PingFang SC;
                            font-size: 14px;
                            line-height: 1;

                            .info-title {
                                width: 56px;
                                color: rgba(132, 134, 145, 1);
                                margin-right: 12px;
                            }

                            .info-value {
                                color: rgba(30, 31, 36, 1);
                            }

                            .info-error {
                                color: #FD503E;
                            }

                            .info-error-title {
                                width: 60px;
                                height: 20px;
                                padding: 3.5px 0;
                                box-sizing: border-box;
                                border-radius: 4px;
                                border: 1px solid rgba(253, 80, 62, 0.4);
                                color: rgba(253, 80, 62, 1);
                                font-family: PingFang SC;
                                font-size: 12px;
                                font-weight: 500;
                                line-height: 12px;
                                margin-right: 8px;
                                text-align: center;
                            }

                            .info-error-value {
                                width: 366px;
                                line-height: 22px;
                                margin-top: -1px;
                            }

                            .info-error-btn {
                                color: #05f;
                                cursor: pointer;
                            }
                        }
                    }
                }
            }

            .upload-zyz:last-child {
                margin-bottom: 0;
            }
        }

        .tip {
            width: 374px;
            margin-top: 24px;
            padding: 24px;
            box-sizing: border-box;
            border-radius: 16px;
            background-image: url('https://lvlin-base.cdn.bcebos.com/fe-saas/common/claim-top-bg.png');
            background-size: 100% 113px;
            background-repeat: no-repeat;
            background-color: #fff;
            box-shadow: 0px 6px 14px 0px rgba(227, 233, 237, 0.35);
            border: 1px solid #fff;

            .tip-title {
                font-family: PingFang SC;
                font-size: 20px;
                font-weight: 600;
                line-height: 20px;
                color: #1E1F24;
                margin-bottom: 20px;
            }

            .tip-prompt {
                font-family: PingFang SC;
                font-size: 14px;
                line-height: 24px;
                color: #848691;
            }

            .tip-case {
                display: flex;
                margin-top: 20px;

                .case-img {
                    width: 220px;
                    height: 136px;
                    display: flex;
                    position: relative;
                    border-radius: 6px;
                    overflow: hidden;

                    img {
                        width: 100%;
                        height: 100%;
                        border: none;
                    }

                    .case-tip {
                        position: absolute;
                        top: 0;
                        left: 0;
                        letter-spacing: 0;
                        padding: 0 6px;
                        background: #dbe7ff;
                        border-top-left-radius: 6px;
                        border-bottom-right-radius: 6px;
                        font-family: PingFang SC;
                        font-size: 12px;
                        font-weight: 500;
                        line-height: 24px;
                        color: #05f;
                    }
                }

                .tip-rule {
                    font-family: PingFang SC;
                    font-size: 14px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;

                    .rule-item {
                        margin: 6px 0;
                        color: #1E1F24;
                    }

                    .rule-icon {
                        width: 16px;
                        height: 16px;
                        vertical-align: middle;
                        margin: 0 6px 0 20px;
                    }
                }
            }
        }
    }

    .declare {
        font-family: PingFang SC;
        font-size: 14px;
        line-height: 54px;
        text-align: center;
        color: #848691;
        padding-bottom: 136px;
    }

    .bottom-box {
        width: 100%;
        height: 136px;
        position: fixed;
        left: 0;
        bottom: 0;
        background: #fff;
        padding: 24px;
        box-sizing: border-box;

        .form-agree {
            width: 1339px;
            margin: 0 auto;
        }

        .form-href-terms {
            font-size: 14px;
            color: #05f;
            cursor: pointer;
        }

        .submit-btn {
            width: 360px;
            height: 44px;
            border-radius: 8px;
            background: rgba(0, 85, 255, 0.4);
            font-family: PingFang SC;
            font-size: 16px;
            font-weight: 500;
            line-height: 44px;
            text-align: center;
            margin: 24px auto;
            color: #fff;
        }

        .submit-btn-blue {
            background: rgba(0, 85, 255, 1);
        }
    }

    /deep/ .veui-field-label {
        width: 80px;
        justify-content: flex-start;
        font-size: 16px;
        margin-right: 0;
        height: 48px;
    }

    /deep/ .veui-field-content {
        width: 396px;
        height: 48px;
        border: 1px solid rgba(233, 236, 243, 1);
        border-radius: 6px;
        font-size: 16px;
        padding-left: 18px;
        box-sizing: border-box;
        position: relative;

        .veui-input {
            width: 95%;
            height: 100%;
            border: none;
            padding: 0;
        }

        .veui-input.veui-focus {
            box-shadow: none;
        }

        .code-text {
            height: 100%;
            position: absolute;
            top: 0;
            right: 18px;
            line-height: 48px;
            font-family: PingFang SC;
            font-size: 16px;
            font-weight: 400;
            text-align: right;
            color: #05f;
            cursor: pointer;
        }
    }

    /deep/ .veui-field-required > .veui-field-label::before {
        color: #FD503E;
    }

    /deep/ .veui-field-label .veui-label {
        color: #1E1F24;
    }

    /deep/ .veui-form .veui-field:not(.veui-field-abstract) {
        margin-bottom: 0;
        margin-top: 24px;
    }

    /deep/ .portrait {
        .veui-uploader-list-media {
            width: 150px;
            height: 150px;
            .veui-uploader-list-media-item {
                position: absolute;
                width: 150px;
                height: 150px;
            }
        }
    }

    /deep/ .veui-input-count {
        display: none;
    }

    /deep/ .veui-input-placeholder {
        color: #B7B9C1;
        font-size: 16px;
    }

    /deep/ .veui-input-input {
        font-size: 16px;
    }

    /deep/ .veui-field-messages {
        display: none;
    }

    /deep/ .veui-number-input-controls {
        display: none;
    }

    .phone-error-tip {
        font-family: PingFang SC;
        font-size: 14px;
        font-weight: 400;
        line-height: 14px;
        padding-left: 78px;
        margin-top: 10px;
        color: #EB3333;
    }

    .phone-error {
        /deep/ .veui-field-content {
            border: 1px solid #FD503E;
        }
    }

    .code-error {
        /deep/ .veui-field-content {
            border: 1px solid #FD503E;
        }

        .phone-error-tip {
            display: block;
        }
    }

    /deep/ .veui-checkbox-box {
        background-color: #05f;
    }

    .mark {
        width: 100%;
        height: 100%;
        position: fixed;
        left: 0;
        top: 0;
        background: rgba(0, 0, 0, 0.5);
        z-index: 110;

        .modal-content {
            width: 360px;
            min-height: 202px;
            border-radius: 8px;
            background: #fff;
            padding: 24px;
            box-sizing: border-box;
            font-family: PingFang SC;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate3d(-50%, -50%, 0);
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .modal-title {
                font-size: 18px;
                font-weight: 500;
                line-height: 18px;
                text-align: center;
                margin-bottom: 20px;
                color: #1E1F24;
            }

            .sub-title {
                font-size: 14px;
                line-height: 22px;
                text-align: center;
                margin-bottom: 20px;
                color: #848691;
            }

            .btn {
                display: flex;
                justify-content: center;

                .btn-item {
                    height: 40px;
                    box-sizing: border-box;
                    margin: 0 10px;
                    border-radius: 8px;
                    font-size: 16px;
                    font-weight: 500;
                    text-align: center;
                    cursor: pointer;
                    padding: 0 24px;
                }

                .btn-left {
                    border: 1px solid #05f;
                    line-height: 38px;
                    color: #05f;
                }

                .btn-right {
                    margin: 0 10px;
                    background: #05f;
                    line-height: 40px;
                    color: #fff;
                }

                .long-btn {
                    min-width: 144px;
                }
            }
        }
    }
}

.claim-suc {
    margin-top: -48px;
}

.result {
    width: 1338px;
    padding: 80px 12px 110px;
    background: #fff;
    border-radius: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    margin: 24px auto;

    .result-icon {
        width: 100px;
        height: 60px;
    }
    .result-title {
        font-family: PingFang SC;
        font-size: 20px;
        font-weight: 600;
        line-height: 1;
        text-align: center;
        color: #1e1f24;
        margin-top: 20px;
    }
    .result-sub-title {
        font-family: PingFang SC;
        font-size: 20px;
        font-weight: 400;
        line-height: 1;
        text-align: center;
        color: #858585;
        margin-top: 16px;

        .sub-title-black {
            color: #1e1f24;
        }
    }
    .result-btn-box {
        width: 100%;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        margin-top: 36px;
    }
    .result-blue-btn {
        width: 200px;
        height: 44px;
        border-radius: 8px;
        line-height: 44px;
        text-align: center;
        background: #05f;
        font-family: PingFang SC;
        font-size: 16px;
        font-weight: 500;
        color: #fff;
        margin: 0 10px;
        cursor: pointer;
    }

    .result-btn {
        width: 200px;
        height: 44px;
        border-radius: 8px;
        line-height: 42px;
        text-align: center;
        font-family: PingFang SC;
        font-size: 16px;
        font-weight: 500;
        color: #05f;
        box-sizing: border-box;
        border: 1px solid #05f;
        margin: 0 10px;
        cursor: pointer;
    }
}
.loading {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    /deep/ .veui-loading-spinner {
        color: #05f;
        height: 20px;
    }

    /deep/ .veui-loading-text {
        color: #1e1f24;
        font-size: 18px;
    }

    /deep/ .veui-loading-spinner .veui-loading-content {
        height: 20px;
    }
}
</style>
